import { ref } from 'vue';
class NotificationCallback {
    /**
     * Unique name of the callback for registration. Best way - use the name of the Job on a page.
     * This will prevent handling "alien" messages.
     * For example, 3 tabs are opened. One has datagrid, 2 others - whatever.
     * First has a subscriber for refreshing datagrid not for any message, but only after a specific trigger.
     * And if any other has a subscriber as well, absolutely each message would trigger datagrid refreshing, which is wrong.
     */
    key;
    /**
     * If true, callback will be called regardless of the {key} name.
     */
    callAlways;
    /**
     * If true, subscribe for a file to be downloaded on this page exactly.
     */
    callDownload;
    /**
     * Function that will be called when a new message comes from the backend
     */
    callback;
    /**
     * Flag to determine, whether subscriber should wait for a message to download a file.
     * Each page should handle this flag as a ref, so no multiple files will be downloaded when few tabs are opened.
     */
    pending;
    // Handle both in a 
    constructor(keyOrOptions, callback = null, callAlways = false, callDownload = false, pending = ref(false)) {
        if (typeof keyOrOptions === "string") {
            this.key = keyOrOptions;
            this.callback = callback;
            this.callAlways = callAlways;
            this.callDownload = callDownload;
            this.pending = pending;
        }
        else {
            this.key = keyOrOptions.key;
            this.callback = keyOrOptions.callback ?? null;
            this.callAlways = keyOrOptions.callAlways ?? false;
            this.callDownload = keyOrOptions.callDownload ?? false;
            this.pending = keyOrOptions.pending ?? false;
        }
    }
}
export default NotificationCallback;
